import { render, staticRenderFns } from "./iotMenu.vue?vue&type=template&id=bb95789e&scoped=true"
import script from "./iotMenu.vue?vue&type=script&lang=js"
export * from "./iotMenu.vue?vue&type=script&lang=js"
import style0 from "./iotMenu.vue?vue&type=style&index=0&id=bb95789e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb95789e",
  null
  
)

export default component.exports